import "./Button.css";
import cn from "classnames";
import type { ComponentPropsWithRef, FC } from "react";
import type { IconType } from "react-icons";
import { TbLoader2 } from "react-icons/tb";

type ButtonVariant = "primary" | "social" | "danger" | "link" | "ghost";

type ButtonSize = "sm" | "md" | "lg";

export interface ButtonProps extends ComponentPropsWithRef<"button"> {
  variant?: ButtonVariant;
  full?: boolean;
  loading?: boolean;
  size?: Exclude<ButtonSize, "md">;

  /** Icon **/
  icon?: IconType;
}

const iconSize: Record<ButtonSize, number> = {
  sm: 16,
  md: 18,
  lg: 20,
};

export const Button: FC<ButtonProps> = (props) => {
  const {
    icon: _icon,
    onClick: _onClick,
    className,
    size = "md",
    variant = "primary",
    loading = false,
    full,
    children,
    type = "button",
    disabled = false,
    ...rest
  } = props;

  const Icon = loading ? TbLoader2 : _icon;
  const onClick = disabled ? undefined : _onClick;

  return (
    <button
      type={type}
      aria-disabled={loading || disabled}
      aria-busy={loading}
      onClick={onClick}
      className={cn("btn", { full }, size, variant, className)}
      {...rest}
    >
      {Icon && (
        <Icon
          size={iconSize[size]}
          className={cn("icon", { spin: loading })}
          role={loading ? "status" : undefined}
        />
      )}
      {children}
    </button>
  );
};
